import { observable } from 'mobx'
import { isEidasIdentifiedUser } from 'todistukset-common/src/vtj/user.utils'
import { isVtjOteTodistus } from 'todistukset-common/src/vtj/CertificateTypes.enum'
import { getVtjOteTodistusSteps } from 'todistukset-ui/src/vtj/components/order-wizard/todistusSteps'
import type { TodistuksetUser } from 'todistukset-common/src/vtj/types/user'
import { getAetOrdererSteps } from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/aetOrdererSteps'
import { getAetSignerSteps } from 'todistukset-ui/src/vtj/components/order-wizard-aet-signer/aetSignerSteps'
import OrderFlowName from 'todistukset-ui/src/vtj/OrderFlowName.enum'
import { getUaetSteps } from 'todistukset-ui/src/vtj/components/order-wizard-uaet/uaetSteps'

export interface StepStore {
  stepCount: number
  currentStep: number
  visitedSteps: boolean[]
  showStepValidationErrors: boolean
}

const createStore = (
  orderFlowName: OrderFlowName,
  user?: TodistuksetUser
): StepStore => {
  const getStepsLength = (
    orderFlowName: OrderFlowName,
    user?: TodistuksetUser
  ) => {
    switch (orderFlowName) {
      case OrderFlowName.ASUINPAIKKATODISTUS:
      case OrderFlowName.ELOSSAOLOTODISTUS:
      case OrderFlowName.AVIOLIITTOTODISTUS:
      case OrderFlowName.SIVIILISAATYTODISTUS:
      case OrderFlowName.SYNTYMATODISTUS:
        if (!isVtjOteTodistus(orderFlowName) || !user) {
          throw new Error('Type check failed. Expected vtjOtetodistus and user')
        }
        return getVtjOteTodistusSteps(
          orderFlowName,
          isEidasIdentifiedUser(user)
        ).length
      case OrderFlowName.AETTODISTUS_ORDERER:
        return getAetOrdererSteps().length
      case OrderFlowName.AETTODISTUS_SIGNER:
        return getAetSignerSteps({}).length
      case OrderFlowName.UAETTODISTUS:
        return getUaetSteps().length
    }
  }

  const stepCount = getStepsLength(orderFlowName, user)

  return {
    stepCount,
    currentStep: -1,
    visitedSteps: new Array(stepCount).fill(false),
    showStepValidationErrors: false,
  }
}

export type StepsStore = Record<OrderFlowName, StepStore>

export const createStepsStore = (user: TodistuksetUser): StepsStore =>
  observable({
    [OrderFlowName.ASUINPAIKKATODISTUS]: createStore(
      OrderFlowName.ASUINPAIKKATODISTUS,
      user
    ),
    [OrderFlowName.ELOSSAOLOTODISTUS]: createStore(
      OrderFlowName.ELOSSAOLOTODISTUS,
      user
    ),
    [OrderFlowName.AVIOLIITTOTODISTUS]: createStore(
      OrderFlowName.AVIOLIITTOTODISTUS,
      user
    ),
    [OrderFlowName.SIVIILISAATYTODISTUS]: createStore(
      OrderFlowName.SIVIILISAATYTODISTUS,
      user
    ),
    [OrderFlowName.SYNTYMATODISTUS]: createStore(
      OrderFlowName.SYNTYMATODISTUS,
      user
    ),
    [OrderFlowName.AETTODISTUS_ORDERER]: createStore(
      OrderFlowName.AETTODISTUS_ORDERER
    ),
    [OrderFlowName.AETTODISTUS_SIGNER]: createStore(
      OrderFlowName.AETTODISTUS_SIGNER
    ),
    [OrderFlowName.UAETTODISTUS]: createStore(OrderFlowName.UAETTODISTUS),
  })
